<template>
  <div id="mockExam2024">
    <mock-header2024 :title="courseName"/>
    <div class="main container" v-if="isRender">
      <div class="sidebar">
      <div class="lnavtit">系统管理目录</div>
      <div class="navcon">
        <ul>
          <li v-for="(item,idx) in menuList" :key="idx" @click="toMenuFn(item.menuID)">
            <span v-text="item.menuName" :class="{active:idx===currentIndex}"/>
          </li>
        </ul>
      </div>
      <common-tips2024 />
    </div>
    <router-view :pre-exam-url="preExamURL" :faqs="faqs" :blessings="blessings" :showStatus.sync="showStatus"/>
    </div>
    <!-- <common-footer/> -->
     <iframe
      src="//www.chinaacc.com/include/vueFooter.shtml"
      width="100%"
      height="198px"
      scrolling="no"
      allowtransparency="true"
      frameborder="0"
      marginheight="0"
      marginwidth="0"
    ></iframe>
  </div>
</template>
<script>
  import { MockHeader2024, CommonFooter, CommonTips2024 } from "@components/common"
  import { parseNumber, LoadingOptions, setPageTitle, getCookie,setCookie } from "@/utils"
  import { getMoniExamTheme } from '@api'

  export default {
    name: "mockExam",
    components: {
      MockHeader2024,
      CommonFooter,
      CommonTips2024
    },
    watch: {
      $route(to) {
        this.getCurrentIndex(to.name)
      }
    },
    computed: {
      isRender() {
        return Object.keys(this.menuList).length > 0
      }
    },
    data() {
      return {
        //Query参数
        courseID: "",
        siteCourseID: "",
        majorID: "",
        flag: "",
        //列表
        courseList: [],
        menuList: [],
        //其他变量
        courseName: "",
        loadingInstance: null,
        currentIndex: 0,
        preExamURL: "",
        faqs: [],
        blessings: {},
        showStatus: true
      }
    },
    async mounted() {
      this.initData()
      await this.getCourseInfo()
      await this.getExamThemeList()
      this.getCurrentIndex(this.$route.name)
    },
    methods: {
      initData() {
        const { majorID } = this.$categoryInfo
        const { flag } = this.$route.params
        const { siteCourseID, courseID } = this.$route.query
        this.flag = flag === 'paidExam' ? '' : flag
        this.majorID = majorID
        this.courseID = parseNumber(courseID)
        this.siteCourseID = parseNumber(siteCourseID)
        this.loadingInstance = this.$loading(LoadingOptions)
      },
      async getCourseInfo() {
        let params = {
          flag: this.flag,
          majorID: this.majorID,
          siteCourseID: this.siteCourseID
        }
        await this.$store.dispatch("getCurrentSiteInfo", params).then(res => {
          const { allSiteList, currentCourse } = res
          this.courseList = allSiteList
          const { siteCourseName } = currentCourse
          document.title = setPageTitle(siteCourseName)
          this.courseName = siteCourseName
          setCookie('courseName',this.courseName)
        }).catch(err => {
          this.$message.error(err.msg)
        })
      },
      async getExamThemeList() {
        const sid = getCookie('sid') || ''
        let params = {
          siteCourseID: this.siteCourseID,
          courseID: this.courseID,
          flag: this.flag
        }
        await getMoniExamTheme(params, sid).then(res => {
          this.$nextTick(() => {
            this.loadingInstance.close()
          })

          const { menu, module } = res
          if (!menu.length) {
            this.$message.error('学员您好，很抱歉本门课程您没有开通。如有疑问请联系客服！')
            return
          }

          this.menuList = menu
          const { blessings, faqs, preExam } = module
          this.preExamURL = preExam.url
          this.faqs = faqs
          this.blessings = blessings
        }).catch(err => {
          this.$message.error(err.msg)
        })
      },
      getCurrentIndex(name) {
        this.menuList.find((item, idx) => {
          if (item.menuID === name) {
            this.currentIndex = idx
            return true
          } else {
            return false
          }
        })
      },
      toggleCourse() {
        this.courseList.forEach(item => {
          if (item.siteCourseID === this.siteCourseID) {
            this.siteCourseID = item.siteCourseID
            this.courseID = item.courseID
            document.title = setPageTitle(item.siteCourseName)
            this.courseName = item.siteCourseName
            const { flag } = this.$route.params
            this.$router.push({
              path: `/${ flag }/mockExam`,
              query: {
                siteCourseID: item.siteCourseID,
                courseID: item.courseID
              }
            })
            this.getCourseInfo()
            this.getExamThemeList()
          }
        })
      },
      toMenuFn(menuID) {
        this.showStatus = true
        const { flag } = this.$route.params
        let queryParams = {
          siteCourseID: this.siteCourseID,
          courseID: this.courseID
        }
        if(menuID === 'examChapter'){
          queryParams.time = (new Date).getTime()
        }
        this.$router.push({
          path: `/${ flag }/mockExam/${ menuID }`,
          query: queryParams
        }).catch(err => {err})
      }
    }
  }
</script>

<style lang="scss" scoped>
    .main {
      background: transparent;
      position: relative;
      overflow: hidden;
      width: 1200px;
      margin: 15px auto;
    }

    .sidebar {
      float:left;
      width:230px;
      .switch {
        width: 216px;
        margin: 0 auto 20px;

        .el-select {
          .el-input__inner {
            border-color: #9cd9ff;
          }
        }
      }

      .lnavtit {
        margin: 0 auto;
        width: 230px;
        height: 46px;
        line-height: 46px;
        background: linear-gradient( top, #F1FBFA, #DDFBFB);
        background: -webkit-linear-gradient( top, #F1FBFA, #DDFBFB);
        color: #07BDC7;
        font-size: 18px;
        text-indent:41px;
        font-weight: bold;
        position:relative;
        &:before{
          content:"";
          width:16px;
          height:14px;
          background: url("~@/assets/images/mockExam/lnavtit-ico01.png") no-repeat;
          position:absolute;
          left:15px;
          top:17px;
        }
      }

      .navcon {
        padding: 10px;
        border-top: none;
        width: 230px;
        background: #fff;
        box-shadow: 0 5px 30px 0 #EFEFEF;
        border-radius:0 0 6px 6px;
        ul {
          margin: 0 auto;
          padding: 0;
          li{ padding:0;
            &:last-child span{ margin-bottom:0;}
          }
          span {
            display: block;
            cursor: pointer;
            width: 210px;
            height: 40px;
            line-height: 40px;
            margin-bottom: 10px;
            text-align: center;
            font-size: 16px;
            color: #333;
            border-radius:8px;
            background: url("~@/assets/images/mockExam/lnavtit-ico02.png") no-repeat 178px center #FAFAFA;

            &:hover {
              background: url("~@/assets/images/mockExam/lnavtit-ico03.png") no-repeat 178px center #07BDC7;
              color: #fff;
            }

            &.active {
              background: url("~@/assets/images/mockExam/lnavtit-ico03.png") no-repeat 178px center #07BDC7;
              color: #fff;
            }
          }
        }
      }

    }

</style>
